<template>
    <div
            :class="{ 'hidden': isExportableMenuHidden, 'opacity-100': !isExportableMenuHidden }"
            class="opacity-0 absolute z-999999 w-216px h-auto bg-white p-4 border border-black rounded-4px shadow-5-20"
    >
        <ul class="">
            <li
                    v-for="(option, indx) in options"
                    class="cursor-pointer h-40px hover:bg-lunar rounded-6 px-s py-11px"
                    @click="exportableClicked(option)">
                {{ option.label }}
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            hide: {
                type: Boolean,
                default: false
            },
            options: {
                type: Array,
                default: () => {
                    return [
                        { label: 'Export to CSV', value: 'csv', api_url: '' },
                        // { label: 'Export to PDF', value: 'pdf', api_url: '' }, // PDF Removed for now, see TEC-6742
                    ];
                }
            },
          companyId: {
              type: Number,
              required: true
          }
        },
        watch: {
            hide(val) {
                this.isExportableMenuHidden = val;
            }
        },
        data() {
            return {
                isExportableMenuHidden: this.hide
            }
        },
        methods: {
            /**
             * @param {object} option
             */
            exportableClicked(option) {
                if (option.api_url) {
                    window.open(option.api_url + '/' + this.companyId, "_blank");
                }else {
                    this.$emit('selected', { optionSelected: 'all', type: option.value });
                }
            }
        }
    }
</script>
